import { Grid, Typography, Button, CircularProgress } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import OtpInput from "react-otp-input";
import { makeStyles, withStyles } from "@material-ui/core";
import { history } from "../../../../helpers/history";
import { routePaths } from "../../../config/route-paths";
import Countdown from 'react-countdown-now';
import { store } from "../../../../helpers/store";
import { userService, commonService, adminService } from '../../../../services';
import { useSelector } from 'react-redux';
import cookie from "react-cookies";
import Alert from "@material-ui/lab/Alert";
import { useLocation } from 'react-router-dom'
import { Skeleton } from '@material-ui/lab';
import { useTranslation } from "react-i18next";
import i18next from "i18next";
const useStyles = makeStyles((theme) => ({
  resendButton: {
    background: theme.palette.ePastelColor2.base + " !important",
    color: theme?.palette?.eWhite?.base + " !important",
    "&:hover": {
      background: theme.palette.ePrimary.base+ " !important"
    },
    borderRadius: "1.125rem !important",
    lineHeight: "1.3rem !important",
    marginLeft: "0.6rem !important"
  },
  alertMessage:{
    color:theme.palette.eDanger.dark,
    backgroundColor:theme.palette.eDanger.light,
  },
  verifyButton: {
    background: theme.palette.ePrimary.base+ " !important",
    color: theme?.palette?.eWhite?.base + " !important",
    "&:hover": {
      background: theme.palette.eSecondary.base + " !important"
    },
    borderRadius: "1.125rem !important",
    lineHeight: "1.3rem !important",
    marginRight: "0.6rem !important"
  },
  disabledButton: {
    background: "none",
    borderRadius: "1.125rem !important",
    lineHeight: "1.3rem !important",

  },
  canceButton: {
    color: theme.palette.ePrimary.base+ " !important",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    },
    marginLeft: "0.5rem !important",
    textTransform: "none"
  },
  verifyOTPTitle: {
    color: theme.palette.ePrimary.base+ " !important",
  },
  otpCustomStyle: {
    fontSize: 30,
    width: 36,  
    height: 36,
    margin: 3.7,
    [theme.breakpoints.down("md")]: {
      padding: 0
    },
  },
  spinnerStyling: {
    color: theme?.palette?.eWhite?.base + " !important",
  },
  errorGrid: {
    width: "90% !important",
    color:theme.palette.eDanger.dark,
    backgroundColor:theme.palette.eDanger.light,
    "& .MuiAlert-icon": {
      marginRight: "0.3rem !important"
    }
  },
  mainDiv:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    [theme.breakpoints.up("sm")]: {
      height: "29rem",
    },
    [theme.breakpoints.up("md")]: {
      height: "24rem",
    },
  }
}));

export default function EVerifyOTP(props) {
  let path = props?.location?.state?.path;
  let userName = props?.location?.state?.userName
  let password = props?.location?.state?.password;
  let customerNumber = props?.location?.state?.customerNumber;
  const [otpLength, setOTPLength] = useState();
  const [enterOptText, setEnterOTPText] = useState();
  const [doNotReceiveText, setDoNotReceiveText] = useState();
  const [resendText, setResendText] = useState();
  const [cookieExpiry, setCookieExpiry] = useState();
  const [invalidotpMessage,setInvalidotpMessage]=useState("")
  const [invalidotpMessageSet,setInvalidotpMessageSet]=useState("")
  const [countInvalid,setCountInvalid]=useState("")
  const [errorInvalidCount,setErrorInvalidCount]=useState(false)
  const {t:labels,ready:labelsReady}=useTranslation("label-E_VERIFY_SIGN_UP_OTP")
  const { t: content, ready: contentReady } = useTranslation("content-E_VERIFY_SIGN_UP_OTP_CONTENT");
  useEffect(() => {
    if (!userName) {
      history.push(routePaths.LOGIN)
    }
  }, [])

  let cookieInfo = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.COOKIE_EXPIRY
  )

  let otpLengthInfo = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.OTP_LENGTH
  )

  let otpCountDownInfo = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.OTP_COUNTDOWN
  )

  let invalidOTPAttempts = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.NO_OF_INVALID_ATTEMPTS_OTP_FLOW
  )
  const lockDurationDefault = useSelector((state) =>
    state?.parametersWidgets?.ParameterLookup?.LOCK_DURATION
  );
  const {t:loginLabels,ready:loginLabelsReady}=useTranslation("label-E_AUTH_LOGIN")
  const [countDownOTP, setCoutnDownOTP] = useState()
  useEffect(() => {
    if (otpCountDownInfo) {
      setCoutnDownOTP(Number(otpCountDownInfo))
    }
    if (cookieInfo) {
      setCookieExpiry(Number(cookieInfo))
    }
    if (otpLengthInfo) {
      setOTPLength(Number(otpLengthInfo))
    }
  }, [otpCountDownInfo, invalidOTPAttempts, cookieInfo, otpLengthInfo])
let message;
  useEffect(() => {
    if(errorInvalidCount)
    message=labelsReady?labels("E_VERIFY_OTP_INVALID_ATTEMPTS"):""
    setInvalidotpMessageSet(message?.replace("**",countInvalid))
    setVerifyState({
      ...verifyState,
      loginClick: false,
      error: true,
      send: false,
      msg: invalidotpMessageSet?invalidotpMessageSet:"",
      otpnotsend: false,
      isSignupLoading: false,
    });
  }, [countInvalid,errorInvalidCount,invalidotpMessage,i18next.language])

  let E_LOGIN_OTP_VALIDATION_FOR_NEW_DEVICE = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_LOGIN_OTP_VALIDATION_FOR_NEW_DEVICE
  )
  const classes = useStyles();
  const [countNumber, setCountNumber] = useState(invalidOTPAttempts);
  const [btnDisable, setBtnDisable] = useState(false);
  const [otp, setOtp] = useState("");
  const [verifyState, setVerifyState] = useState()
  const [timeCountdown, setTimeCountdown] = useState()
  const [countdownerror, setCountdownerror] = useState(false)
  const [resendExpireTitle, setResendExpireTitle] = useState()

  useEffect(() => {
    if (countDownOTP) {
      setVerifyState({
        submitButton: true,
        otpRequired: false,
        otpError: false,
        error: false,
        send: false,
        otpnotsend: false,
        otpid: "",
        isSignupLoading: false,
        isResendLoading: false,
        msg: "",
        loginClick: false,
        countDownStart: true,
        countdown: Date.now() + 1000 * countDownOTP,
        otploginerror: "",
        blockUser: false
      })
    }
  }, [countDownOTP])


  useEffect(() => {
    if (contentReady) {
          setVerifyState({
            ...verifyState,
            otploginerror: contentReady ? content("OTP_LOGIN_ERROR").answer : ""
      })
    }
  }, [contentReady])

  const contextMenuHandler = (e) => {
    e.preventDefault();
  }

 const ctrlKeydownHandler = (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  }

  useEffect(()=>{
    window.addEventListener("contextmenu", contextMenuHandler,{capture:true});
    window.addEventListener("keydown", ctrlKeydownHandler,{capture:true});
    return () =>{
      window.removeEventListener("contextmenu", contextMenuHandler,{capture:true});
      window.removeEventListener("keydown", ctrlKeydownHandler,{capture:true});

    } 
  },[])

  const backCall = () => {
    history.push(path);
  };
  const Colon = ':'
  const countDown = ({ minutes,seconds, completed }) => {
    let newAfter = `${labelsReady?labels("E_COUNTDOWN_FIRST_PART_TEXT"):""} ` + minutes+Colon+seconds + ` ${labelsReady?labels("E_OTP_SECONDS_TEXT"):""}`;
    if (completed) {
      setVerifyState({
        ...verifyState,
        countDownStart: false
      })

      return (
        <React.Fragment>
          {countNumber > 1 ? (
            <Typography
              align="center"
              variant="subtitle2"
            >
              {contentReady ? content("E_RECEIVE_OTP_TEXT").answer : <Skeleton/>}
            </Typography>
          ) : (
            <span></span>
          )}
        </React.Fragment>
      );
    } else {
      return (
        <Typography
          align="center"
          variant="caption"
        >
          {newAfter}
        </Typography>
      );
    }
  };
  function countDowninMinutes({ minutes, completed }) {
    let newAfter = loginLabels("E_USER_BLOCKED")?.replace("***", minutes + 1);
    if (completed) {
      setCountdownerror(false)
      return (
        <div>
          <span></span>
        </div>
      );
    } else {
      return (
        <div>
          <React.Fragment>
            <Alert className={classes.alertMessage} severity="error">
              <Typography
                className={classes.whiteColor}
                variant="caption"
                align="center"
                dangerouslySetInnerHTML={{
                  __html: newAfter,
                }}
              />
            </Alert>
          </React.Fragment>
        </div>
      );
    }
  }
  const handleChange = (value) => {
    setOtp(value)
    setVerifyState({
      ...verifyState,
      submitButton: false,
      otpRequired: false,
      otpError: false,
      error: false,
      send: false,
      otpnotsend: false,
    })
    if (value.length < otpLength) {
      setVerifyState({
        ...verifyState,
        submitButton: true,
      });
    }
  }
  const toResendOTP = () => {
    const otpid = verifyState?.otpid;
    setVerifyState({
      submitButton: true,
      isResendLoading: true
    });
    setOtp("");
    if (userName) {
      userService
        .resendCommonOTP(userName, otpid)
        .then((response) => {
          setVerifyState({
            ...verifyState,
            countDownStart: true
          })
          if (response?.data?.otpId) {
            setVerifyState({
              ...verifyState,
              otpid: response.data.otpId,
              send: true,
              error: false,
              submitButton: true,
              countdown: Date.now() + 1000 * countDownOTP,
              isResendLoading: false,
            });
          } else {
            setVerifyState({
              ...verifyState,
              error: false,
              submitButton: true,
              countDownStart: true,
              countdown: Date.now() + 1000 * countDownOTP,
              isResendLoading: false
            });
            setCountNumber(response.data.count)
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            setVerifyState({
              otpnotsend: true,
              submitButton: true,
              isResendLoading: false
            });
          } else if (error.response.status === 403) {
            setVerifyState({
              error: false,
              loginClick: true,
              msg: error.response.data.message,
              submitButton: true,
              isResendLoading: false
            });
            setBtnDisable(true)
          } else {
            setVerifyState({
              send: false,
              error: true,
              loginClick: false,
              msg: error.response.data.message,
              otpnotsend: false,
              submitButton: true,
              isResendLoading: false
            });
          }
        });
    }
    else {
      history.push(routePaths.LOGIN);
    }

  }

  const otpBlur = () => {
    if (otp) {
      setVerifyState({
        ...verifyState,
        otpRequired: false,
        error: false,
        otpnotsend: false,
      });
      if (otp.length === otpLength) {
        setVerifyState({
          ...verifyState,
          otpError: false,
          otpnotsend: false,
        });
      } else {
        setVerifyState({
          ...verifyState,
          otpError: true,
          otpRequired: false,
          error: false,
          send: false,
          otpnotsend: false,
        });
      }
    } else {
      setVerifyState({
        ...verifyState,
        otpRequired: true,
        otpError: false,
        error: false,
        send: false,
        otpnotsend: false,
        submitButton: true,
      });
    }
  }
  const handleSubmit = (e) => {
  
    e.preventDefault();
    if (verifyState?.submitButton === false) {
      otpBlur()
      if (
        otp &&
        verifyState?.otpRequired === false &&
        verifyState?.otpError === false &&
        otp.length === otpLength
      ) {
        setVerifyState({
          ...verifyState,
          isSignupLoading: true,
        })
        let isLoginNewDevice = false;
        const storeState = store.getState();
        if (E_LOGIN_OTP_VALIDATION_FOR_NEW_DEVICE) {
          isLoginNewDevice = true;
        }
        if (userName) {
          if(path=="/login/forgot-password"){
            localStorage.setItem("flowType","FORGOT_PASSWORD");
          }else if(path=="/register"){
            localStorage.setItem("flowType","SIGNUP");
          }
          else{
            localStorage.setItem("flowType","LOGIN_OTPVERIFIED");
          }
          userService.validateOTP({ userName, otp, password,customerNumber})
            .then((response) => {
              localStorage.removeItem("flowType");
              if (path === routePaths.REGISTER && response?.data?.isOk === true) {
                history.push({pathname: routePaths.ACTIVATE_EMAIL, state: { path: routePaths.SIGN_UP_VERIFY_OTP }})
              } else if (path === routePaths.FORGOT_PASSWORD && response?.data?.sessionId) {
                history.push({
                  pathname: routePaths.FORGOT_PASSWORD,
                  state: { path: routePaths.LOGIN_VERIFY_OTP, userName: userName, sessionId: response?.data?.sessionId }
                })
              }
              else if (path === routePaths.LOGIN_VIA_OTP && response?.data?.accountDetails) {
                if (isLoginNewDevice === true) {
                  let date = new Date();
                  date.setDate(date.getDate() + cookieExpiry);
                  cookie.save("QC_DSS", "QC_DSS", { path: "/", expires: date });
                }
                localStorage.clear();
                localStorage.setItem(
                  "bearer",
                  commonService.encodeString(JSON.stringify(response?.data))
                );
                localStorage.setItem("firstLogin",true);
                commonService.gotoMainApp();
              } else {
                history.push(routePaths.LOGIN);
              }
              setVerifyState({
                isSignupLoading: false,
              });
            })
            .catch((error) => {
              if (error && error.response && error.response.status === 500) {
                setVerifyState({
                  ...verifyState,
                  otpnotsend: true,
                  isSignupLoading: false,
                });
              } else if(error && error.response && error.response.data.statusCode === 400){
                setErrorInvalidCount(true);
                let message=error.response.data.message.split('|')
                setCountInvalid(message?message[0]:"")
                setInvalidotpMessage(message?message[1]:"")
                return;
              }
              else if (error.response && error.response.status === 403) {
                if(error.response.data.message === "INACTIVE_SA"){
                  setVerifyState({
                    error: true,
                    msg: loginLabels?loginLabels("E_INACTIVESA_ERROR"):"",
                  });
                  return;
                }
                setVerifyState({
                  isSignupLoading: false,
                  blockUser: true,
                  error: false,
                  submitButton: true
                });
                if (error.response.data.message === "E_USER_BLOCKED") {
                  setTimeCountdown(Date.now() + 60000 * lockDurationDefault)
                } else {
                  setTimeCountdown(Date.now() + 60000 * error.response.data.message)
                }
              } else {
                setVerifyState({
                  ...verifyState,
                  loginClick: false,
                  error: true,
                  send: false,
                  msg: error?.response?.data?.message,
                  otpnotsend: false,
                  isSignupLoading: false,
                });
              }
            });
        }
        else {
          history.push(routePaths.LOGIN);
        }
      }

    }
  }
  return (
    <div className={classes.mainDiv}>
      <Grid container justify='space-around'>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant="h5" className={classes.verifyOTPTitle}>
            {labelsReady?labels("E_VERIFICATION_CODE_TITLE"):""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant="caption">
            {contentReady ? content("E_ENTER_OTP_TEXT").answer  : <Skeleton animation="wave" />}
          </Typography>
        </Grid>
      </Grid>
      <Grid container justify='space-around'>
        <OtpInput
          numInputs={otpLength}
          onChange={handleChange}
          separator={<span></span>}
          shouldAutoFocus={true}
          isInputNum={true}
          value={otp}
          inputStyle={classes?.otpCustomStyle}
          containerStyle={{
            margin: "1.25rem auto",
            padding: "0.6rem",
            justifyContent: "center"
          }}
        />
      </Grid>
      <Grid container justify='space-around'>
        <Grid item>
          <Button
            variant="contained"
            className={(verifyState?.countDownStart || btnDisable || verifyState?.blockUser) ? classes.disabledButton : classes.resendButton}
            disabled={
              verifyState?.countDownStart || btnDisable || verifyState?.blockUser
            }
            onClick={toResendOTP}
          >
            {labelsReady?labels("E_RESEND_BUTTON_TITLE"):""}
            {verifyState?.isResendLoading && <CircularProgress size={15} className={classes.spinnerStyling} />}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            className={verifyState?.submitButton ? classes.disabledButton : classes.verifyButton}
            disabled={verifyState?.submitButton}
            onClick={handleSubmit}
          >
            {labelsReady?labels("E_VERIFY_BUTTON_TITLE"):""}
            {verifyState?.isSignupLoading && <CircularProgress size={15} className={classes.spinnerStyling} />}
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Button
            className={classes.canceButton}
            size="small"
            onClick={backCall}
          >
            <Typography variant="caption">
              {labelsReady?labels("E_CANCEL_BUTTON_TITLE"):""}
            </Typography>
          </Button>
        </Grid>
      </Grid>
      <Grid container justify='space-around'>
        <Grid item>
          {verifyState?.countDownStart && countDownOTP && labels("E_OTP_AFTER_TEXT") && (
            <Countdown
              date={countDownOTP && verifyState?.countdown}
              renderer={countDown}
            />
          )}
        </Grid>

        <Grid item xs={12} className={classes.errorGrid}>
          {verifyState?.blockUser ?
            (
              <React.Fragment>
                <Countdown
                  date={timeCountdown}
                  renderer={countDowninMinutes}
                />
              </React.Fragment>)
            : null}
        </Grid>
      </Grid>
      <Grid container justify='space-around'>
        <Grid item>
          {verifyState?.countDownStart === false &&
            verifyState?.error === false &&
            verifyState?.send === false &&
            btnDisable === false ? (
            <Typography
              align="center"
              variant="caption"
            >
              {contentReady ? content("E_RECEIVE_OTP_TEXT").answer : <Skeleton/>}
            </Typography>
          ) : null}
        </Grid>

      </Grid>
      <Grid container justify='space-around'>
        <Grid item>
          <Grid container justify='space-around'>
            {verifyState?.error === true && (
              <Alert severity="error" className={classes.errorGrid}>{verifyState?.msg}</Alert>
            )}
            {verifyState?.otpnotsend === true && (
              <Alert severity="error" className={classes.errorGrid}>{contentReady ? content("E_RESEND_EXPIRE_TEXT").answer : <Skeleton/>}</Alert>
            )}
          </Grid>
        </Grid>
        <Grid item>
          {verifyState?.loginClick &&
            (path === routePaths.LOGIN_VERIFY_OTP || routePaths.LOGIN_VERIFY_OTP) ? (
            <Alert severity="error" className={classes.alertMessage}>
              <Typography
                className={classes.contentHeading}
                variant="caption"
                dangerouslySetInnerHTML={{
                  __html: contentReady ? content("E_RESEND_OTP_EXPIRE_TITLE").answer : "",
                }}
              ></Typography>
            </Alert>
          ) : null}
        </Grid>
      </Grid>
    </div>
  )
}
